import { render, staticRenderFns } from "./VodacomCompetition.vue?vue&type=template&id=0dd496e6&scoped=true"
import script from "./VodacomCompetition.vue?vue&type=script&lang=js"
export * from "./VodacomCompetition.vue?vue&type=script&lang=js"
import style0 from "./VodacomCompetition.vue?vue&type=style&index=0&id=0dd496e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd496e6",
  null
  
)

export default component.exports